const { CHANNELINCHAT } = require("constants/channels")

const getActiveUserFromState = (getOldState) => {
  const activeUser = getOldState().tabs.activeUser
  const activeChannel = getOldState().tabs.activeChannel

  const user = CHANNELINCHAT.includes(activeChannel)
    ? getOldState().inchat.conversations[activeUser].user
    : getOldState().conversations[activeUser].user
  return Object.assign({}, user)
}

const getActiveUserId = (getState) => {
  return getState().tabs.activeUser
}

const getNxAuthTokenFromState = (getState) => getState().nxAuthToken.token

const getWallIdFromState = (getState) => getState().wall.data._id

export { getActiveUserFromState, getActiveUserId, getNxAuthTokenFromState, getWallIdFromState }
